var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-title',{attrs:{"img":_vm.img,"title":"企业文化"}}),_c('div',{staticClass:"container"},_vm._l((_vm.imgList),function(item,index){return _c('img',{key:index,attrs:{"src":item.file_path,"alt":""}})}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }